import React, { Fragment, useEffect, useState } from 'react';

//Componentes
import LcLoading from '../../../components/Generic/LcLoading';

//Serviços
import { FinOpsService } from '../../../services/finOps/finOpsService';
import { formatCurrency, formatDecimal } from '../../../services/currency';

//Service
import { CostCenterService } from '../../../services/costCenter/costCenterService';
import moment from 'moment';
import "./index.css"
//IMport do css do PPTable para componente adaptado
import '../../../components/Data/PPTable/index.css';
import LCDashboard from '../../../components/Data/Dashboard/LCDashboard';
import LcIconLink from '../../../components/Generic/LcIconLink';

interface BudgetProps {
    onEdit: Function,
    visibleMode: number,
    showInactives: boolean
}

const Budget: React.FC<BudgetProps> = (props) => {

    //Services
    const finOpsService = new FinOpsService(props);
    const costCenterService = new CostCenterService(props);

    const [loading, setLoading] = useState(false);
    const [budgetData, setBudgetData] = useState<any>();
    const [ccs, setCCs] = useState<string[]>([]);
    const [columns, setColumns] = useState<any[]>([]);
    const [ccData, setCCData] = useState<any[]>([]);

    const getBudget = (month: string, budgetData: any) => {
        if (!budgetData) return 0;
        let budgetMensal = budgetData.monthBudget?.find(mb => mb.month === month)?.value;
        let val = budgetMensal !== undefined ? budgetMensal : (budgetData.budget || 0);
        return val || 0;
    }

    const loadData = async () => {
        setLoading(true);

        var ccdata = await (await costCenterService.GetTreeDataWithBudget()).data as any;
        var filteredCCData = props.showInactives ? ccdata : [...ccdata].filter(cc => cc.active == true)
        setCCData(filteredCCData);

        let columns: any[] = [{
            field: 'name', headerName: 'Créditos e consumo', width: "25%",
            renderCell: (row) => {
                if (row.name.includes('.'))
                    return <span style={{ marginLeft: '20px' }}>{row.name.replace('.', '')}</span>
                else
                    return <strong>{row.name}</strong>
            }
        }];
        finOpsService.LoadBudgetvsUsagebyGroupFull()
            .then(response => {

                let _budgetData = response.map(b => {
                    return {
                        ccId: b.parent.title,
                        value: b.parent.value,
                        date: b.parent.date.substring(0, 7),
                        total: b.total
                    }
                });

                let ccs = [...new Set(_budgetData.map(b => b.ccId))].sort((a, b) => { return a > b ? 1 : -1 });
                setCCs(ccs);

                let months = [...new Set(_budgetData.map(b => b.date))].sort((a, b) => { return a > b ? 1 : -1 });

                //Montar colunas
                months.forEach(m => {
                    columns.push(
                        {
                            field: m,
                            headerName: moment(m.replace('-', '') + '01', "YYYYMMDD").format("MMM[/]YY"),
                            width: `${75 / m.length}%`,
                            align: "right"
                        });
                })

                setColumns(columns);

                let structured: any[] = [];

                ccs.forEach(cc => {

                    let thisCC: any = {
                        cc,
                        show: false,
                        children: [],
                        active: [...filteredCCData].find(costcenter => costcenter.id == parseInt(cc))?.active ?? true
                    };

                    let newRowA: any = { name: "Créditos acumulados", show: false };
                    let newRowA1: any = { name: "Créditos no começo do período" };
                    let newRowA2: any = { name: "Novos créditos" };
                    let newRowB: any = { name: "Consumo" };
                    let newRowC: any = { name: "Saldo acumulado" };

                    let sobra = 0;

                    months.forEach(m => {

                        let budget = getBudget(m, ccdata.find(ccd => ccd.id.toString() == cc));
                        let value = _budgetData.find(b => b.ccId == cc && b.date == m)?.value || 0;

                        //Data
                        var calcBudget = budget + sobra;
                        var calcValue = value;
                        var calcSaldo = (calcBudget - calcValue);

                        newRowA[m] = props.visibleMode == 0 ? formatDecimal(calcBudget) : calcPercent(calcBudget, budget);
                        newRowA1[m] = props.visibleMode == 0 ? formatDecimal(sobra) : calcPercent(sobra, budget);
                        newRowA2[m] = props.visibleMode == 0 ? formatDecimal(budget) : calcPercent(budget, budget);
                        newRowB[m] = props.visibleMode == 0 ? formatDecimal(calcValue) : calcPercent(calcValue, budget);
                        newRowC[m] = props.visibleMode == 0 ? formatDecimal(calcSaldo) : calcPercent(calcSaldo, budget);

                        sobra = calcSaldo;
                    });

                    thisCC.children.push(newRowA, newRowA1, newRowA2, newRowB, newRowC);
                    structured.push(thisCC);
                });

                setBudgetData(structured);
            })
            .catch(console.error)
            .then(() => {
                setLoading(false);
            })
    }

    const calcPercent = (value: number, base: number) => {
        return (base === 0) ? 'N/A' : ((value / base) * 100).toFixed(1) + '%';
    }

    useEffect(() => {
        loadData();
    }, [props.visibleMode, props.showInactives])

    const assembleBody = (data) => {

        let show = data.show;

        return <>
            <div className="row">
                <div className="cells">
                    {
                        columns.map((c, i) => {
                            return <div key={i} className={`cell small  ${c.align || ''}${i == 0 ? ' bold' : ''}`} style={{ width: c.width, color: data.active ? "#2b304f" : "#2b304fad" }}>
                                {data.children[0][c.field]}
                                {
                                    i == 0 &&
                                    <i className="ppi ppi-chevron-down-alt ppi-3x link" onClick={() => {
                                        data.show = !data.show;
                                        setBudgetData([...budgetData]);
                                    }} />
                                }
                            </div>
                        })
                    }
                </div>
            </div>
            <div className="row" style={{ display: show ? "" : "none" }}>
                <div className="cells">
                    {
                        columns.map((c, i) => {
                            return <div key={i} className={`cell small ${c.align || ''}${i === 0 ? ' pl-7' : ''} `} style={{ width: i=== 0 ? c.width : '11.1%' , color: data.active ? "#2b304f" : "#2b304fad" }}>{data.children[1][c.field]}</div>
                        })
                    }
                </div>
            </div>
            <div className="row" style={{ display: show ? "" : "none" }}>
                <div className="cells">
                    {
                        columns.map((c, i) => {
                            return <div key={i} className={`cell small ${c.align || ''}${i == 0 ? ' pl-7' : ''}`} style={{ width: i=== 0 ? c.width : '11.1%', color: data.active ? "#2b304f" : "#2b304fad" }}>{data.children[2][c.field]}</div>
                        })
                    }
                </div>
            </div>
            <div className="row">
                <div className="cells">
                    {
                        columns.map((c, i) => {
                            return <div key={i} className={`cell small ${c.align || ''}${i == 0 ? ' bold' : ''}`} style={{ width: c.width, color: data.active ? "#2b304f" : "#2b304fad" }}>{data.children[3][c.field]}</div>
                        })
                    }
                </div>
            </div>
            <div className="row">
                <div className="cells">
                    {
                        columns.map((c, i) => {
                            return <div key={i} className={`cell small ${c.align || ''}${i == 0 ? ' bold' : ''}`} style={{ width: c.width, color: data.active ? "black" : "#2b304fad" }}>{data.children[4][c.field]}</div>
                        })
                    }
                </div>
            </div>
        </>
    }
    const cards = [{
        title: () => {
            return <div className="lc-title ellipsis">Orçamento</div>
        },
        type: 'Custom', position: { ColSpan: 12, RowSpan: 4, row: 1, col: 1 },
        customContentRender: () => {
            return <div className="chart-container" >
                <div className=" scrollable-v" >
                    <LcLoading loading={loading} label="Carregando..." >
                        {
                            ccs.length > 0 ?
                                ccs.map((cc, i) => {

                                let ccd = ccData.find(ccd => ccd.id.toString() == cc);

                                    if (ccd) {

                                    return <div key={i} style={{ color: ccd.active ? "#2b304f" : "#2b304fad" }}>
                                        <h5>Centro de custo: {ccd.name}</h5>
                                        <div className='row'>
                                            <h6 >
                                                Orçamento mensal atual: {formatCurrency(ccd.budget)}
                                                {/* <i className={`ppi ppi-pencil ppi-2x ml-5 ${ccd.active ? 'link' : ''}`} onClick={() => ccd.active ? props.onEdit(cc) : null} /> */}
                                            </h6>
                                            <LcIconLink icon={`ppi ppi-pencil ${ccd.active ? 'link' : ''}`} tooltipPosition='left' size='small' onClick={() => ccd.active ? props.onEdit(cc) : null} tooltip='Editar centro de custo'  /> 
                                        </div>
                                        {
                                            !(props.visibleMode == 1 && ccd.budget == 0) ?
                                                <>
                                                    {
                                                        budgetData &&
                                                        <div className="pp-table"
                                                            style={{ height: budgetData.find(bd => bd.cc == cc).show ? '175px' : '115px' }}
                                                        >
                                                            <div className="header">
                                                                <div className="cells">
                                                                    {
                                                                        columns.map((c, i) => {
                                                                            return <div key={i} className={`cell  ${c.align || ''}`} style={{ width: c.width, color: ccd.active ? "#2b304f" : "#2b304fad" }}>
                                                                                <span>{c.headerName}</span>
                                                                            </div>
                                                                        })
                                                                    }
                                                                </div>
                                                            </div>

                                                            <div className="body highdensity">
                                                                {assembleBody(budgetData.filter(bd => bd.cc == cc)[0])}
                                                            </div>
                                                        </div>
                                                    }
                                                </>
                                                :
                                                <h5>Não é possível calcular os valores em percentuais quando o orçamento está zerado</h5>
                                        }
                                        <hr />
                                    </div>
                                }
                            })
                            :
                            <div className="centralized p-7">
                                <i className="lci lci-exclamation lci-2x text-warning" />
                                Não foram encontrados dados de orçamento.
                            </div>
                    }
                </LcLoading> </div> </div>
        }
    }]

    return <LcLoading loading={loading} label='Carregando orçamentos...'>
        <LCDashboard
            cards={cards} />
    </LcLoading>;
}

export default Budget;